import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Input from 'components/Form/Input';

import './search-field.scss';

const SearchField = ({
    placeholder,
    type,
    onSubmit,
    onChange,
    onFocus,
    onBlur,
    value,
    tag,
    autoFocus,
    stopTriggerByEnter,
    inputRef,
    disabled,
}) => {

    const elWrapper = useRef();
    const elInput = useRef(inputRef?.current);

    const sendRequest = () => {
        onSubmit(elInput.current.value);
    };

    const handleClick = e => {
        if (stopTriggerByEnter) {
            e.preventDefault();
        }

        if (tag !== 'form') {
            sendRequest();
        }
    };

    const handleSubmit = e => {
        e.preventDefault();

        sendRequest();
    };

    const handleChange = e => {
        e.preventDefault();

        onChange(e.currentTarget.value);
    };

    const handleKeyDown = e => {
        let stop = (stopTriggerByEnter && e.keyCode === 13);

        if (stop) {
            e.preventDefault();
        }

        return !stop;
    };
    // prevent safari bug which is input can't focus
    const handleInputClick = e => {
        e.preventDefault();
    }

    const Wrapper = tag;

    return (
        <Wrapper
            ref={ elWrapper }
            className="search-field"
            onSubmit={ handleSubmit }
        >
            <Input
                innerRef={ elInput }
                type={ type }
                name="search-text"
                placeholder={ placeholder }
                autoComplete="off"
                onClick={ handleInputClick }
                onChange={ handleChange }
                onFocus={ onFocus }
                onBlur={ onBlur }
                onKeyDown={ handleKeyDown }
                value={ value }
                autoFocus={ autoFocus }
                disabled={ disabled }
            />
            <button type="submit" className="go-search" onClick={ handleClick } disabled={ disabled }>
                <span className="fas fa-search" />
            </button>
        </Wrapper>
    );
};
SearchField.propTypes = {
    placeholder: PropTypes.string,
    type: PropTypes.string,
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.node,
    tag: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.func,
    ]),
    autoFocus: PropTypes.bool,
    stopTriggerByEnter: PropTypes.bool,
    inputRef: PropTypes.shape({}),
    disabled: PropTypes.bool,
};
SearchField.defaultProps = {
    placeholder: '',
    type: 'text',
    onSubmit: () => {},
    onChange: () => {},
    onFocus: () => {},
    onBlur: () => {},
    value: undefined,
    tag: 'form',
    autoFocus: false,
    stopTriggerByEnter: false,
    inputRef: undefined,
    disabled: false,
};

export default SearchField;
